import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import Paper from "@mui/material/Paper";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import {
  getSearchResults,
  setSearchText,
  getResults,
} from "../../actions/results";
import { useHistory } from "react-router-dom";

const PREFIX = 'Search';

const classes = {
  root: `${PREFIX}-root`,
  input: `${PREFIX}-input`,
  button: `${PREFIX}-button`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    display: "flex",
    alignItems: "center",
    width: "30vw",
    minWidth: "15em",
    maxWidth: "30vw",
    height: "3rem",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "80%",
    },
  },

  [`& .${classes.input}`]: {
    marginLeft: theme.spacing(1),
    flex: 1,
    opacity: "1 !important",
    color: "#000 !important",
    "&::placeholder": {
      opacity: "1 !important",
      color: "#000 !important",
    },
    "&::-webkit-input-placeholder": {
      color: "#000",
      opacity:
        "1 !important" /* for older chrome versions. may no longer apply. */,
    },
    "&:-moz-placeholder": {
      /* Firefox 18- */ color: "#000",
      opacity: "1 !important",
    },
    "&::-moz-placeholder": {
      /* Firefox 19+ */ color: "#000",
      opacity: "1 !important",
    },
    "&:-ms-input-placeholder": {
      color: "#000",
      opacity: "1 !important",
    },
  },

  [`& .${classes.button}`]: {}
}));

const Search = ({ getSearchResults, setSearchText, getResults, showClear }) => {

  const history = useHistory();

  const search = () => {
    if (!history.location.pathname.includes("library")) {
      history.push("library");
    }
    const qs = document.querySelector("#search");
    getSearchResults(qs.value);
    qs.value = "";
    window.scrollTo(0, 0);
  };

  const clear = () => {
    const qs = document.querySelector("#search");
    qs.value = "";
    getResults();
    setSearchText("");
  };

  const onKeyDown = (e) => {
    const value = e.keyCode;
    if (value === 13) {
      search();
    }
  };

  return (
    <Root>
      <Paper className={classes.root}>
        <InputBase
          id="search"
          onKeyDown={onKeyDown}
          className={classes.input}
          placeholder="Search the Library"
          inputProps={{ "aria-label": "search input" }}
          size="small"
        />
        {showClear ? (
          <IconButton
            className={classes.button}
            label="clear search"
            aria-label="clear search"
            alt="clear search"
            onClick={clear}
          >
            <ClearIcon />
          </IconButton>
        ) : (
          <Fragment />
        )}
        <IconButton
          className={classes.button}
          aria-label="search"
          alt="search"
          onClick={search}
        >
          <SearchIcon sx={{color: "rgba(0, 0, 0, 0.54) !important"}} />
        </IconButton>
      </Paper>
    </Root>
  );
};

const mapStateToProps = (state) => ({
  showClear: state.results.searchText.length > 0 ? true : false,
});

Search.propTypes = {
  getSearchResults: PropTypes.func.isRequired,
  setSearchText: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  getSearchResults,
  setSearchText,
  getResults,
})(Search);
